export interface MarkerAppearance {
  id: string;
  imageUrl?: string;
}

/** Specific portrait when that look has one, otherwise the default portrait. */
export function portraitUrl(
  fallback: string | undefined,
  appearances: readonly MarkerAppearance[],
  appearanceId: string | undefined,
): string | undefined {
  if (appearanceId !== undefined) {
    const match = appearances.find((item) => item.id === appearanceId);
    if (match?.imageUrl !== undefined) {
      return match.imageUrl;
    }
  }
  return fallback;
}

export function appearanceByCharacter(
  participants: readonly { characterId: string; appearanceId?: string }[],
): Record<string, string> {
  const map: Record<string, string> = {};
  for (const participant of participants) {
    if (participant.appearanceId !== undefined) {
      map[participant.characterId] = participant.appearanceId;
    }
  }
  return map;
}
